import React from "react";
import { newModelWith } from "../reducers/models";

export const CONTACT_TYPE = {
    ADDRESS: "ADDRESS",
    GROUP: "GROUP"
};

const contactSchema = {
    emailAddress: React.PropTypes.string,
    firstName: React.PropTypes.string,
    lastName: React.PropTypes.string,
    type: React.PropTypes.string
};
export function contactWith(values = {}) {
    const defaults = {
        type: CONTACT_TYPE.ADDRESS
    };

    return newModelWith(values, defaults, contactSchema);
}

export function contactGroupWith(values = {}) {
    const schema = {
        id: React.PropTypes.string,
        name: React.PropTypes.string,
        authorName: React.PropTypes.string,
        authorId: React.PropTypes.string,
        contacts: React.PropTypes.arrayOf(React.PropTypes.shape(contactSchema)),
        type: React.PropTypes.string
    };
    const defaults = {
        type: CONTACT_TYPE.GROUP,
        contacts: []
    };

    return newModelWith(values, defaults, schema);
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/contacts/contactsModels.js
 **/